module.exports = require('./helpers/bundle-url').getBundleURL('2FVrc') + "logo-dark.eefe0b7f.svg";